import React from "react";
import ModernLoader from "./ModernLoader";
import SkeletonLoader from "./SkeletonLoader";
import SimpleLoader from "./SimpleLoader";

const LoadingPage = ({
  children,
  isLoading = true,
  alterElement = null,
  skeletonType = null,
  skeletonCount = 1,
  loadingText = "Loading...",
  className = "",
  useSimpleLoader = true
}) => {
  const simpleLoader = (
    <div 
      className="flex items-center justify-center w-full min-h-[500px]"
      aria-label={loadingText}
      role="status"
    >
      <SimpleLoader 
        size="large" 
        text={loadingText}
        className={className}
      />
    </div>
  );

  const modernLoader = (
    <div 
      className="flex items-center justify-center w-full min-h-[500px]"
      aria-label={loadingText}
      role="status"
    >
      <ModernLoader 
        size="large" 
        text={loadingText} 
        variant="primary"
        className={className}
      />
    </div>
  );

  const skeletonLoader = (
    <div 
      className="w-full"
      aria-label={`Loading ${skeletonCount} ${skeletonType || 'item'}${skeletonCount > 1 ? 's' : ''}`}
      role="status"
    >
      <SkeletonLoader 
        type={skeletonType} 
        count={skeletonCount} 
        className={className}
      />
    </div>
  );

  if (isLoading) {
    if (alterElement) {
      return alterElement;
    }
    if (skeletonType) {
      return skeletonLoader;
    }
    return useSimpleLoader ? simpleLoader : modernLoader;
  }

  return children;
};

export default LoadingPage;
